export const LABELS = {
  applyButtonLabel: 'Apply',
  archived: 'Archived',
  archivedDescription: 'This issue was archived in this project.',
  archivedError: 'Issue could not be restored in project',
  archivedSuccess: 'Issue restored in project',
  cancelButtonLabel: 'Cancel',
  editTitle: 'Rename issue',
  emptySections: {
    labels: 'No labels',
    assignees: (viewerCanAssign: boolean) => (viewerCanAssign ? 'Unassigned - ' : 'No assignees'),
    selfAssign: 'Assign yourself',
    milestones: 'No milestones',
    branchesOrLinkedPullRequests: 'No branches or linked pull requests',
    relations: 'None yet',
    projects: 'No projects',
    participants: 'No participants',
    development: 'No branches or pull requests',
    status: 'No status',
    noValue: (fieldName: string) => `No ${fieldName.toLowerCase()}`,
    iterationPlaceholder: 'Choose an iteration',
    datePlaceholder: 'Choose a date',
    numberPlaceholder: 'Enter number…',
    iterationFilterPlaceholder: 'Filter options',
    singleSelectFilterPlaceholder: 'Filter options',
  },
  filterProjects: 'Filter projects',
  issueNumber: (issueNumber: number) => `#${issueNumber}`,
  issueTypes: {
    noIssueTypeOptionName: 'No issue type',
    issueTypeDialogHeader: 'Change issue type',
    selectIssueType: 'Select issue type',
  },
  lock: {
    title: 'Lock conversation on this issue',
    titleUnlock: 'Unlock conversation on this issue',
    buttonConfirmLock: 'Lock conversation',
    buttonConfirmUnlock: 'Unlock conversation',
  },
  milestones: {
    noDueDate: 'No due date',
    dueOn: (dueDate: string) => {
      const dueOn = new Date(Date.parse(dueDate))
      return `Due on ${dueOn.toLocaleString('default', {month: 'short'})} ${dueOn.getDate()}`
    },
    progressPercentage: (progress: number) => (progress ? `, ${Math.round(progress)}% complete` : ', not started'),
  },
  noDescriptionProvided: 'No description provided.',
  notifications: {
    unsubscribedAnnouncement: "You're now unsubscribed from this issue.",
    unsubscribedButton: 'Subscribe',
    unsubscribedDescription: "You're not receiving notifications from this thread.",
    subscribedAnnouncement: "You're now subscribed to this issue.",
    subscribedButton: 'Unsubscribe',
    subscribedDescription: "You're receiving notifications because you're subscribed to this thread.",
  },
  private: 'Private',
  prPickerDescription: 'Link pull requests',
  public: 'Public',
  pullRequest: 'Pull request',
  repository: 'Repository',
  sectionTitles: {
    assignees: 'Assignees',
    labels: 'Labels',
    milestones: 'Milestones',
    projects: 'Projects',
    relations: 'Relations',
    development: 'Development',
    participants: 'Participants',
  },
  selectProjects: 'Select projects',
  tasks: (completed: number, total: number) =>
    completed === 0 ? `${total} task${total > 1 ? 's' : ''}` : `${completed} of ${total}`,
  timeline: {
    pinned: 'pinned this issue',
  },
  transfer: {
    title: 'Transfer issue',
    subtitle:
      'This does not scrub any issue content. Content such as text references to other issues, pull requests, projects and teams will still appear in the description or comments. Labels will be transferred.',
    started: 'Issue transfer has started. This action might take a while.',
    repoUnavailable: 'Issue cannot be transferred to this repository.',
  },
  unsavedChangesContent: 'Are you sure you want to discard them?',
  unsavedChangesTitle: 'You have unsaved changes',
  viewDescriptionPlaceholder: 'Add a description',
  viewTitlePlaceholder: 'Title',
  showClosedProjects: 'Show closed projects',
  showMoreProjectFields: 'Show more project fields',
  mergedPrs: 'Fixed by',
  openPrs: 'May be fixed by',
  linkedPullRequests: (mergedPrs: number, openPrs: number) =>
    mergedPrs > 0
      ? `Fixed by ${mergedPrs} pull request${mergedPrs > 1 ? 's' : ''}${openPrs > 0 ? ` • ${openPrs} remaining` : ''}`
      : `May be fixed by ${openPrs} pull requests`,
}
